module.exports = __webpack_public_path__ + "img/certification.455d5613.png";